import 'intersection-observer'

function init(el, callback, option) {
  const observer = new IntersectionObserver(callback, option)
  observer.observe(el)
  return () => {
    observer.unobserve(el)
    observer.disconnect()
  }
}

export default ({ app }, inject) => {
  inject('observer', init)
}
